import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import DataTable from "../../assets/components/dataTable";
import NotificationActions from "../../store/actions/notification";
import MemberSearchSelect from "../../assets/components/MemberSearchSelect";
import { Button } from "semantic-ui-react";
import EventBooking from "../../models/EventBooking";
import moment from "moment";
import MemberChip from "../../assets/components/MemberChip";

class EventsIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            table: {
                page: 1,
                term: "",
                sort: "createdAt",
                order: "asc",
                limit: 25,
            },
            filters: {
                member: null,
            },
            totalRecords: 0,
            bookings: [],
            notification: null,
            error: false,
        };

        if (this.props.user.has("MASHIE_ADMIN") === false) {
            this.props.history.push("/members");
        }
    }

    componentWillUnmount() {
        this.props.dispatch(NotificationActions.remove());
    }

    notification(type, text) {
        this.props.dispatch(NotificationActions.create({ type, text }));
    }

    table() {
        const headers = [
            { key: "event", text: "Event" },
            { key: "venue", text: "Venue" },
            { key: "maxAttendees", text: "Max Attendees" },
            { key: "member", text: "Member" },
            { key: "players", text: "Players" },
            { key: "eventDate", text: "Event date" },
            { key: "bookingDate", text: "Booking date" },
            { key: "actions", text: "Actions" },
        ];

        const data = this.state.bookings.map((booking) => {
            return {
                event: {
                    value: booking.event ? (
                        <Link to={`/events/${booking.event._id}`}>
                            {booking.event.name}
                        </Link>
                    ) : (
                        "Event not found"
                    ),
                    search: booking.event?.name ?? "Event not found",
                },
                venue: {
                    value: booking.event?.club ? (
                        <Link to={`/golf-clubs/${booking.event.club._id}`}>
                            {booking.event.club.name}
                        </Link>
                    ) : (
                        "Venue not found"
                    ),
                    search: booking.event?.club?.name ?? "Venue not found",
                },
                maxAttendees: { value: booking.event?.maxUsers ?? "-" },
                member: {
                    value: <MemberChip member={booking.user} />,
                    search: booking.user.name,
                },
                players: { value: booking.players },
                eventDate: {
                    value: booking.event
                        ? moment(booking.event.date).format("DD/MM/YYYY")
                        : "",
                },
                bookingDate: {
                    value: booking.createdAt
                        ? moment(booking.createdAt).format(
                              "DD/MM/YYYY HH:mm:ss",
                          )
                        : "-",
                },
                actions: {
                    value: (
                        <Link to={`/events/bookings/${booking._id}`}>
                            <Button primary className='theme'>
                                View
                            </Button>
                        </Link>
                    ),
                },
            };
        });

        return (
            <DataTable
                loading={this.state.loading}
                headers={headers}
                data={data}
                totalRecords={this.state.totalRecords}
                page={this.state.table.page}
                onChange={this.getBookings.bind(this)}
                searchTerm={this.state.table.term}
                sort={this.state.table.sort}
                order={this.state.table.order}
                limit={this.state.table.limit}
                sortOptions={[
                    { text: "Booking date", key: "createdAt" },
                    { text: "Event (grouped)", key: "event" },
                    { text: "Players", key: "players" },
                    { text: "Member (grouped)", key: "user" },
                ]}
                pagination
            />
        );
    }

    getBookings(params) {
        this.setState({ loading: true });
        EventBooking.index(Object.assign(params, this.state.filters))
            .then((data) => {
                this.setState({
                    table: params,
                    totalRecords: data.total,
                    loading: false,
                    bookings: data.bookings,
                });
            })
            .catch((error) => {
                this.setState({ loading: false, error: true });
                this.notification("error", "Failed to load. Please try again");
            });
    }

    componentDidMount() {
        this.getBookings(this.state.table);
    }

    onChangeFilter(property, value) {
        const { filters, table } = this.state;
        filters[property] = value;
        table.page = 1;
        this.setState({ filters, table });
        this.getBookings(table);
    }

    body() {
        return (
            <div className='container-fluid' style={{ overflowX: "scroll" }}>
                <div className='row page-header mt-3'>
                    <div className='col'>
                        <h2>Event bookings</h2>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className='col'>
                        <h3>Filters</h3>
                        <MemberSearchSelect
                            multiple
                            onChange={(value) =>
                                this.onChangeFilter("member", value)
                            }
                            value={this.state.filters.member}
                            placeholder='Filter by member'
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>{this.table()}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />

                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
    };
}

export default connect(mapStateToProps)(EventsIndex);
